/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { VehicleFeaturesPropagationItemsAgreed } from './VehicleFeaturesPropagationItemsAgreed';
export type VehicleFeatureAgreed = {
  featureCode: VehicleFeatureAgreed.featureCode;
  agreeYn: boolean;
  agreedDate: string;
  propagationItemsAgreedList: Array<VehicleFeaturesPropagationItemsAgreed>;
};
export namespace VehicleFeatureAgreed {
  export enum featureCode {
    EV_ENERGY_USAGE = 'EV_ENERGY_USAGE',
    TRIPS = 'TRIPS',
    SAFETY_SCORE = 'SAFETY_SCORE',
    UBI = 'UBI',
    DI = 'DI',
  }
}

